<template>
  <div>
    <Content />
    <!-- DRAWER COMENTADO TEMPORARIAMENTE PARA MIGRAÇÃO VUE 3 -->
    <!-- <Drawer
      @close="openModalTermo"
      :align="'right'"
      :closeable="true"
      :maskClosable="false"
      :zIndex="100002"
    >
      <div v-if="openTermo">
        <div class="cursor-pointer text-gray-600 w-full items-center border-b border-t-neutral-700 border-solid px-2 pb-4">
          <h2 class="text-sm font-semibold text-gray-900" id="slide-over-title">{{ titleTermo }}</h2>
        </div>
        <Termo :participant="participant" @headerDrawerTermo="updateTitle"/>
      </div>
    </Drawer> -->
  </div>
</template>

<script>
// import Drawer from "vue-simple-drawer"; // COMENTADO - não tem versão Vue 3
import Termo from "./termo.vue";
import Content from "./content.vue";
import { identify } from "../services/api/identify";
import { notification } from "@/services/notification";

export default {
  name: "confirma-termos",
  components: {
    // Drawer, // COMENTADO
    Content,
    Termo,
  },
  data: () => ({
    openTermo: false,
    participant: {},
    titleTermo: "INSCRIÇÃO - PAGAMENTO",
  }),
  methods: {
    openModalTermo() {
      this.openTermo = !this.openTermo;
    },
    updateTitle(title) {
      this.titleTermo = title;
    },
    async getParticipant(uuid) {
      try {
        let resp;
        resp = await identify(uuid);
        this.participant = resp.resp;
        this.openModalTermo();
      } catch (err) {
        notification.error(
          err?.errMsg ?? "Houve um problema para concluir inscrição"
        );
        console.log(err);
        return;
      }
    },
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("identify") && urlParams.get("identify")) {
      this.getParticipant(urlParams.get("identify"));
    }
  },
};
</script>
<style scoped lang="scss"></style>